import React, { useState } from 'react';
import { Mail, Phone, FileText, Download } from 'lucide-react';
import { kanbanStages } from '../data/mockData';
import { useCRM } from '../context/CRMContext';
import ClientDrawer from './ClientDrawer';

const Contacts = () => {
  const { policies: contacts } = useCRM();
  const [selectedClient, setSelectedClient] = useState(null);

  const getStageTitle = (stageId) => {
    return kanbanStages.find(s => s.id === stageId)?.title || stageId;
  };

  const handleExportCSV = () => {
    const headers = ['Nombre', 'Telefono', 'Email', 'Tipo', 'Valor Original', 'Fase/Estado', 'Fecha Ingreso'];
    
    const rows = contacts.map(c => [
      `"${c.clientName || ''}"`,
      `"${c.phone || ''}"`,
      `"${c.email || ''}"`,
      `"${c.type || ''}"`,
      `"${c.value || ''}"`,
      `"${getStageTitle(c.stage)}"`,
      `"${c.date || ''}"`
    ]);

    const csvContent = [headers.join(';'), ...rows.map(r => r.join(';'))].join('\n');
    
    // Añadimos indicador BOM para que Excel lea los tildes y ñ correctamente
    const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Contactos_VeritasVas_${new Date().toLocaleDateString('es-CL').replace(/\//g, '-')}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="animate-fade-in">
      <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1>Base de Contactos</h1>
          <p className="text-muted">Gestiona tus prospectos y clientes de forma rápida.</p>
        </div>
        <button 
          className="btn" 
          onClick={handleExportCSV} 
          style={{ backgroundColor: 'white', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: '0.5rem', boxShadow: 'var(--shadow-sm)' }}
        >
          <Download size={18} color="var(--primary)" /> 
          <span style={{ fontWeight: 600 }}>Exportar a Excel (CSV)</span>
        </button>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead style={{ backgroundColor: 'var(--secondary)', borderBottom: '1px solid var(--border)' }}>
            <tr>
              <th style={{ padding: '1rem 1.5rem', fontWeight: 600, color: 'var(--text-muted)', fontSize: '0.85rem' }}>CLIENTE</th>
              <th style={{ padding: '1rem 1.5rem', fontWeight: 600, color: 'var(--text-muted)', fontSize: '0.85rem' }}>ESTADO</th>
              <th style={{ padding: '1rem 1.5rem', fontWeight: 600, color: 'var(--text-muted)', fontSize: '0.85rem' }}>PRODUCTO</th>
              <th style={{ padding: '1rem 1.5rem', fontWeight: 600, color: 'var(--text-muted)', fontSize: '0.85rem' }}>FECHA INGRESO</th>
              <th style={{ padding: '1rem 1.5rem', fontWeight: 600, color: 'var(--text-muted)', fontSize: '0.85rem', textAlign: 'right' }}>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((contact, idx) => (
              <tr 
                key={contact.id} 
                style={{ borderBottom: idx !== contacts.length - 1 ? '1px solid var(--border)' : 'none', cursor: 'pointer', transition: 'background-color 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--secondary)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                onClick={() => setSelectedClient(contact)}
              >
                <td style={{ padding: '1rem 1.5rem' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div className="avatar" style={{ width: 32, height: 32, fontSize: '0.8rem', backgroundColor: 'var(--info)' }}>
                      {contact.clientName.charAt(0)}
                    </div>
                    <div>
                      <div style={{ fontWeight: 500, color: 'var(--text-main)', marginBottom: '0.1rem' }}>{contact.clientName}</div>
                      <div className="text-muted" style={{ fontSize: '0.8rem' }}>{contact.phone}</div>
                    </div>
                  </div>
                </td>
                <td style={{ padding: '1rem 1.5rem' }}>
                  <span style={{ 
                    padding: '0.25rem 0.5rem', 
                    backgroundColor: 'var(--bg-color)', 
                    border: '1px solid var(--border)', 
                    borderRadius: '4px', 
                    fontSize: '0.8rem',
                    fontWeight: 500 
                  }}>
                    {getStageTitle(contact.stage)}
                  </span>
                </td>
                <td style={{ padding: '1rem 1.5rem' }}>
                  <div style={{ fontWeight: 500 }}>{contact.type}</div>
                  <div className="text-muted" style={{ fontSize: '0.8rem' }}>{contact.value}</div>
                </td>
                <td style={{ padding: '1rem 1.5rem' }} className="text-muted">
                  {contact.date}
                </td>
                <td style={{ padding: '1rem 1.5rem', textAlign: 'right' }}>
                  <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                    <button className="action-btn email" title="Enviar Archivo"><FileText size={18} /></button>
                    <button className="action-btn email" title="Enviar Email"><Mail size={18} /></button>
                    <button className="action-btn whatsapp" title="Llamar"><Phone size={18} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ClientDrawer client={selectedClient} onClose={() => setSelectedClient(null)} />
    </div>
  );
};

export default Contacts;
